import { render } from "./SpaAddonMud.vue?vue&type=template&id=ae972620&scoped=true"
import script from "./SpaAddonMud.vue?vue&type=script&lang=js"
export * from "./SpaAddonMud.vue?vue&type=script&lang=js"

import "./SpaAddonMud.vue?vue&type=style&index=0&id=ae972620&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae972620"]])

export default __exports__